import { render, staticRenderFns } from "./UserBindAccount.vue?vue&type=template&id=88fb7e1a&scoped=true&"
import script from "./UserBindAccount.vue?vue&type=script&lang=js&"
export * from "./UserBindAccount.vue?vue&type=script&lang=js&"
import style0 from "./UserBindAccount.vue?vue&type=style&index=0&id=88fb7e1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fb7e1a",
  null
  
)

export default component.exports